export const INITIAL_START_VALUE = 0;
export const INITIAL_END_VALUE = 5;
export const INITIAL_TRANSLATE_VALUE = 0;
